module.exports = __webpack_public_path__ + "img/MilitaryTabClicked_ua.eee35af9.webp";